import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f2718a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ub fw ub-ac ub-pc zhezhao detail-load"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("请完善必填项信息哦")
const _hoisted_3 = {
  class: "ub ub-ver fw print-div",
  id: "flow-print-table"
}
const _hoisted_4 = { class: "ub ub-ac ub-pb fw bgfff header" }
const _hoisted_5 = { class: "ub ub-ac ub-pc title" }
const _hoisted_6 = { class: "ub ub-ac ub-pc sub-title" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "col24" }
const _hoisted_9 = {
  key: 0,
  class: "ub fw",
  style: {"background-color":"#ffffff"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "interval-footer" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("保存并提交")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = { class: "biz-template" }
const _hoisted_16 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_NoviceGuide = _resolveComponent("NoviceGuide")
  const _component_attachment = _resolveComponent("attachment")
  const _component_print_item = _resolveComponent("print-item")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_space = _resolveComponent("a-space")
  const _component_a_form = _resolveComponent("a-form")
  const _component_check_circle_filled = _resolveComponent("check-circle-filled")
  const _component_a_modal = _resolveComponent("a-modal")
  const _directive_perm = _resolveDirective("perm")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ub ub-ver fw flow-print", {'in-iframe':_ctx.isIframe}])
  }, [
    (_ctx.editLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_spin, {
            spinning: _ctx.editLoading,
            class: "ub spin-loading detail-load-spin"
          }, null, 8, ["spinning"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_form, {
      style: {"min-height":"calc(100vh - 181px)","background":"#fff"},
      ref: "formRef",
      layout: 'horizontal',
      model: _ctx.formModel,
      rules: _ctx.formRules,
      labelAlign: "right",
      scrollToFirstError: _ctx.scrollOption,
      "label-col": { style: { width: _ctx.labelWidth+'px' } },
      onSubmit: _ctx.submitFn
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NoviceGuide, {
          onHidden: _ctx.hiddenTip,
          positionClass: _ctx.positionClass,
          showButton: false,
          duration: _ctx.duration,
          errorShow: _ctx.errorShow
        }, {
          content: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onHidden", "positionClass", "duration", "errorShow"]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loopSection, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item.show&&item.value==='header')
                ? _renderSlot(_ctx.$slots, "header", { key: 0 }, () => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "subTitle", {}, undefined, true)
                      ])
                    ])
                  ], true)
                : _createCommentVNode("", true),
              (item.show && item.value !=='header' && item.value !== 'qrcode')
                ? (_openBlock(), _createBlock(_component_print_item, {
                    key: 1,
                    class: _normalizeClass([index==1?'first-print-item':'',index==_ctx.loopSection.length-1?'last-print-item':'']),
                    item: item
                  }, {
                    header: _withCtx(() => [
                      (item.titleSlot)
                        ? _renderSlot(_ctx.$slots, item.titleSlot, { key: 0 }, undefined, true)
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.label), 1))
                    ]),
                    body: _withCtx(() => [
                      _renderSlot(_ctx.$slots, item.value, {}, () => [
                        _createElementVNode("div", _hoisted_8, [
                          (item.value === 'attach')
                            ? (_openBlock(), _createBlock(_component_attachment, {
                                key: 0,
                                ref_for: true,
                                ref: "attachRef",
                                value: _ctx.attachList,
                                "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.attachList) = $event)),
                                "allow-edit": true,
                                isEdit: _ctx.isEdit,
                                "biz-type": _ctx.attachBizType
                              }, null, 8, ["value", "isEdit", "biz-type"]))
                            : _createCommentVNode("", true)
                        ])
                      ], true)
                    ]),
                    _: 2
                  }, 1032, ["class", "item"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.showFormFooter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", {
                  class: "ub ub-ac ub-pc fw detail-footer",
                  style: _normalizeStyle({width:_ctx.isIframe?'calc(100% + 32px)':(_ctx.collapsed?'calc(100% - 80px)':'calc(100% - 200px)'),left:_ctx.isIframe?'-16px':(_ctx.collapsed?'80px':'200px')})
                }, [
                  _createVNode(_component_a_space, { size: 16 }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "footer", {}, () => [
                        (_ctx.isEdit)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 0,
                              "data-type": "submit",
                              "html-type": "submit",
                              type: "primary",
                              disabled: _ctx.isChange||_ctx.isEditSave,
                              loading: _ctx.editLoading ||_ctx.loading
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"]))
                          : (_openBlock(), _createBlock(_component_a_button, {
                              key: 1,
                              "data-type": "submit",
                              "html-type": "submit",
                              type: "primary",
                              disabled: _ctx.isChange||_ctx.isEditSave,
                              loading: _ctx.createLoading|| _ctx.loading
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])),
                        (_ctx.examineAccess&&_ctx.examineAccess!='')
                          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                              key: 2,
                              "data-type": "submitAndAdd",
                              "html-type": "submit",
                              disabled: _ctx.loading,
                              type: "primary",
                              loading: _ctx.editLoading ||_ctx.loading
                            }, {
                              default: _withCtx(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"])), [
                              [_directive_perm, _ctx.examineAccess]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_button, { onClick: _ctx.cancel }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _renderSlot(_ctx.$slots, "footer-external", {}, undefined, true)
                      ], true)
                    ]),
                    _: 3
                  })
                ], 4)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["model", "rules", "scrollToFirstError", "label-col", "onSubmit"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.bizTypeVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.bizTypeVisible) = $event)),
      title: "选择流程",
      "confirm-loading": _ctx.loading,
      centered: true,
      onOk: _ctx.handleSubmit,
      wrapClassName: 'biz-modal'
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bizTypeDatas, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass({'active':_ctx.checkedBizType==item.bizType}),
              onClick: $event => (_ctx.selectTemplate(item.bizType))
            }, [
              _createTextVNode(_toDisplayString(item.bizTypeName) + " ", 1),
              _createVNode(_component_check_circle_filled, { class: "icon" })
            ], 10, _hoisted_16))
          }), 256))
        ])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk"])
  ], 2))
}